// data/languages/yoruba/categories/temps.ts
//
// Les jours de la semaine viennent de la tradition : Ọjọ́ Ajé = jour d'Ajé
// (divinité de la richesse), Ọjọ́ Ìṣẹ́gun = jour de la victoire, etc.

import { CategoryData } from '../../../../types/types';

export const temps: CategoryData = {
  'Ọjọ́ Ajé': { translation: 'Lundi', translationEn: 'Monday', audio: 'Yo-Ojo_Aje', illustration: '1️⃣' },
  'Ọjọ́ Ìṣẹ́gun': { translation: 'Mardi', translationEn: 'Tuesday', audio: 'Yo-Ojo_Isegun', illustration: '2️⃣' },
  'Ọjọ́rú': { translation: 'Mercredi', translationEn: 'Wednesday', audio: 'Yo-Ojoru', illustration: '3️⃣' },
  'Ọjọ́bọ̀': { translation: 'Jeudi', translationEn: 'Thursday', audio: 'Yo-Ojobo', illustration: '4️⃣' },
  'Ọjọ́ Ẹtì': { translation: 'Vendredi', translationEn: 'Friday', audio: 'Yo-Ojo_Eti', illustration: '5️⃣' },
  'Ọjọ́ Àbámẹ́ta': { translation: 'Samedi', translationEn: 'Saturday', audio: 'Yo-Ojo_Abameta', illustration: '6️⃣' },
  'Ọjọ́ Àìkú': { translation: 'Dimanche', translationEn: 'Sunday', audio: 'Yo-Ojo_Aiku', illustration: '7️⃣' },
  'Òní': { translation: 'Aujourd\'hui', translationEn: 'Today', illustration: '📍' },
  'Àná': { translation: 'Hier', translationEn: 'Yesterday', illustration: '⬅️' },
  'Ọ̀la': { translation: 'Demain', translationEn: 'Tomorrow', illustration: '➡️' },
  'Ọjọ́': { translation: 'Jour', translationEn: 'Day', illustration: '📆' },
  'Ọ̀sẹ̀': { translation: 'Semaine', translationEn: 'Week', illustration: '🗓️' },
  'Oṣù': { translation: 'Mois', translationEn: 'Month', illustration: '📅' },
  'Ọdún': { translation: 'Année', translationEn: 'Year', illustration: '🎆' },
  'Àárọ̀': { translation: 'Matin', translationEn: 'Morning', illustration: '🌅' },
  'Ọ̀sán': { translation: 'Après-midi', translationEn: 'Afternoon', illustration: '☀️' },
  'Ìrọ̀lẹ́': { translation: 'Soir', translationEn: 'Evening', illustration: '🌇' },
  'Alẹ́': { translation: 'Nuit', translationEn: 'Night', illustration: '🌙' },
  'Wákàtí': { translation: 'Heure', translationEn: 'Hour', illustration: '⏰' },
  'Ìṣẹ́jú': { translation: 'Minute', translationEn: 'Minute', illustration: '⏱️' },
  'Nísinsìnyí': { translation: 'Maintenant', translationEn: 'Now', illustration: '⌛' },
};

export default temps;
